import React from 'react'
import Switch from 'lib/ui/form/Switch'
import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {onChangeCheckedHandler} from 'lib/dom'

export default function SignatureRequiredSwitch() {
  const {waiver} = useTemplate()
  const save = useSaveTemplate()
  const handleToggle = (signatureRequired: boolean) => {
    save({
      waiver: {
        signatureRequired,
      },
    })
  }

  return (
    <Switch
      checked={waiver.signatureRequired}
      onChange={onChangeCheckedHandler(handleToggle)}
      aria-label="toggle signature required"
      label="Signature required"
      labelPlacement="end"
    />
  )
}
